import { useFormatMessage } from '@/translations/useFormatMessage'
import {
	Overlay,
	ScheduleCard,
	CardContent,
	Heading,
	Message,
	Divider,
	CardFooter,
	RefreshButton,
} from './NoActiveSchedule.styled'

// Shared source of truth for API codes that map to the "no active schedule" state.
// Used by LocationPage (raw error.code check) and MenuLayout (via toI18nKey — must only contain
// codes present in ERROR_CODES['olo:menu'] in toI18nKey.ts, otherwise toI18nKey falls through
// to 'generic' and SCHEDULE_UNAVAILABLE_KEYS absorbs all unknown menu API errors).
export const SCHEDULE_UNAVAILABLE_CODES = new Set(['SCHDNONEAVAIL', 'SCHDNA'])

export function NoActiveSchedule() {
	const { t } = useFormatMessage()
	return (
		<Overlay aria-labelledby="no-active-schedule-title">
			<ScheduleCard>
				<CardContent>
					<Heading id="no-active-schedule-title">
						{t('component:noActiveSchedule:heading')}
					</Heading>
					<Message>{t('component:noActiveSchedule:message')}</Message>
				</CardContent>
				<Divider />
				<CardFooter>
					<RefreshButton onClick={() => window.location.reload()}>
						{t('component:noActiveSchedule:refreshButton')}
					</RefreshButton>
				</CardFooter>
			</ScheduleCard>
		</Overlay>
	)
}
